import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { App, LoadingController, Modal, ModalController, NavController, NavParams } from 'ionic-angular';
import { SessionProvider } from '../../../../../../providers/session/session';
import { ValueProvider } from '../../../../../../providers/value/value';
import { MysportUserProfilePage } from '../../../../../me/mysport/mysport-user-profile/mysport-user-profile';
import { TeamSettingsModal } from '../../../../../team-settings-modal/team-settings-modal';
import { TournamentService, PlanEnum } from '../../../services/tournament.service';

@Component({
  selector: 'plan-result-main',
  templateUrl: 'plan-result-main.html',
})
export class PlanResultsMainPage {
  activePlan: number = 0;
  reloader: boolean = true;

  constructor(
    private app: App,
    private modalCtrl: ModalController,
    public gs: TournamentService,
    private sessionService: SessionProvider,
    private loadingCtrl: LoadingController,
    private translate: TranslateService,
    private valueService: ValueProvider
  ) { 

  }

  ionViewWillEnter(){
    let loader = this.loadingCtrl.create({});
    loader.present();
    this.gs.getPlanList().then(t => {
      loader.dismiss();
      this.reload();
    }).catch(e => {
      loader.dismiss();
    });
  }

  reload(){
    this.reloader = false;
    setTimeout(() => {
      this.reloader = true;
    });
  }


  onAddPlan(){
    this.app.getRootNav().getActiveChildNav().select(1);
  }

  openTeamSettings(){
    let modal = this.modalCtrl.create(TeamSettingsModal);
    modal.onDidDismiss(option => {
    })
    modal.present();
  }
  
  onOpenSettings(){
    let modal = this.modalCtrl.create(TeamSettingsModal);
    modal.present();
  }
  
  showLogin(){
    let loader = this.loadingCtrl.create({
      content: this.translate.instant('GLOBAL_LOADING')
    });
    // loader.present();

    this.valueService.getProfileBackgrounds().then(backgrounds => {
      (this.app.getRootNav() as NavController)
        .push(MysportUserProfilePage, {
          data: { profile: this.sessionService.profile, backgrounds: backgrounds }
        })
        // .then(() => loader.dismiss());
    });
  }

  public isLoged(): boolean {
    return this.sessionService.isLoged;
  }

  public profileImage(): string {
    return this.sessionService.profile.profilePicLink || 'assets/imgs/default-image-32@1x.png';
  }

  public get plan(): typeof PlanEnum{
    return PlanEnum;
  }
}

export interface IGamePlan {
  id: number;
  gameDay: number;
  name: string;
  team1: {
    id: number;
    name: string;
  };
  team2: {
    id: number;
    name: string;
  }
}






// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/results/main/plan-result-main.ts